<template>
  <div>
    <Modal v-model="visible" title="请选择需要转入结算的对账单" :footer-hide="true" :mask-closable="false" width="99%" class="my-modal top">
      <span>*仅支持将上游首期基础费用转入业务员结算</span>
      <div class="search-tools">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
          <div class="input-item">
            <span class="label">对账单名称</span>
            <Input v-model="searchParams.reconciliationName" placeholder="请输入" clearable />
          </div>
          <div class="input-item">
            <span class="label">对账类型</span>
            <Select v-model="searchParams.reconciliationType" clearable :transfer="true">
              <Option value="1">首期基础费用</Option>
            </Select>
          </div>
          <div class="input-item">
            <span class="label">对账状态</span>
            <Select v-model="searchParams.reconciliationStatus" clearable :transfer="true">
              <Option value="1">对账正常</Option>
              <Option value="3">已对账</Option>
            </Select>
          </div>
          <div class="input-item">
            <span class="label">对账日期</span>
            <DatePicker transfer v-model="searchParams.reconciliationDate" format="yyyy-MM-dd" type="date" @on-change="searchParams.reconciliationDate = $event"
              placeholder="请选择"></DatePicker>
          </div>
          <div class="input-item">
            <span class="label">供应商类型</span>
            <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
              <Radio label="">全部</Radio>
              <Radio label="1">保险公司</Radio>
              <Radio label="2">合作通道</Radio>
            </RadioGroup>
          </div>
          <div class="input-item" v-if="searchParams.supplierType">
            <span class="label">供应商</span>
            <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
              <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
            </Select>
          </div>
          <div class="btn-item">
            <Button type="primary" @click="searchAjax()">查询</Button>
            <Button type="primary" ghost @click="resetSearch()">重置</Button>
            <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起
              <Icon type="ios-arrow-up" />
            </Button>
            <Button type="primary" ghost v-else @click="searchMore = true">展开
              <Icon type="ios-arrow-down" />
            </Button>
          </div>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >条，共<span>{{ total }}</span
            >条数据</span
          >
        </div>
      </div>

      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange"> 
          <template slot-scope="{ row, index }" slot="reconciliationName">
            <div @click="lookStatement(row)" class="toDetailPage">
              {{ row.reconciliationName }}
            </div>
          </template>
          <template slot-scope="{ row }" slot="reconciliationStatusDesc">
            <div>
              <i class="dian red" v-if="row.reconciliationStatus == 2"></i>
              {{ row.reconciliationStatusDesc }}
            </div>
          </template>
        </Table>
      </div>
      <Page
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center; margin-top: 20px;"
      />
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="ok" :loading="loading" size="default">转入结算报表</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal" ></confirm-modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import lzDicSelect from "@/components/commons/lzDicSelect";
import confirmModal from '@/components/commons/confirmModal2';
import filter from '@/api/filter';
export default {
  mixins: [pageTool, common],
  components: { lzDicSelect,confirmModal },
  data() {
    return {
      visible: false,
      loading: false,
      searchParams: {},
      supplierList: [],
      reportId:'',
      infoForm:{},
      total: null,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: "对账日期",
          align: "center",
          key: "reconciliationDate",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "对账单名称",
          align: "center",
          slot: "reconciliationName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "对账状态",
          align: "center",
          slot: "reconciliationStatusDesc",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "对账类型",
          align: "center",
          key: "reconciliationTypeDesc",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "总保费",
          align: "center",
          key: "premium",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "保单量",
          align: "center",
          key: "policyNum",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "批单量",
          align: "center",
          key: "billNum",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "上游费用",
          align: "center",
          key: "commission",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "签约供应商",
          align: "center",
          key: "supplierName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "签约机构",
          align: "center",
          key: "organizationName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "签约协议",
          align: "center",
          key: "agreementName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "核收人",
          align: "center",
          key: "reviewer",
          minWidth: 120,
          tooltip: true,
        },
      ],
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
    };
  },
  methods: {
    lookStatement(row){
      this.openPageTabTags( '/offline/getAccounts/detail',{ id: row.id,step:row.step,backUrl: this.delQueStr(this.$route.fullPath, 'time') }
      );
    },
    async open(val1,val2) {

      this.isAll = false;
      this.selectArr = [];
      this.reportId = val1;
      this.infoForm = val2;
      this.searchAjax()
      
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all'
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
      this.getList();
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/userSettlementData/queryReconciliationList',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchParams,
          reportId:this.reportId,
          orgIds:this.infoForm.orgIds
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
          if(!this.visible){
            if(res.data && res.data.length>0){
              this.visible = true;
            }else{
              this.$notice.error('没有已对账或对账正常的对账单可以转入结算');
            }
          }
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
    ok() {
      const selectIds = this.selectArr.map(item => item.id);
      if (!this.isAll && this.selectArr.length == 0) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }
      let params = {};
      if (this.isAll) {
        params = {
          ...this.searchParams,
          reportId:this.reportId,
          orgIds:this.infoForm.orgIds,
          isAll: 1,
          reconciliationIds: selectIds,
        };
      } else {
        params = {
          ...this.searchParams,
          reportId: this.reportId,
          orgIds:this.infoForm.orgIds,
          isAll: 0,
          reconciliationIds: selectIds,
        };
      }
      this.$http({
        url: '/buz/userSettlementData/startTransferSettle',
        type: 'POST',
        data: params
      }).then(res => {
        if(res.data.commissionLogIds && res.data.commissionLogIds.length>0){
          this.$refs.confirmModal.open({
            title: '提示',
            content: '对账单中有强平数据，是否按照强平后的上游数据以及上下游比例关系同步调整业务员的费用。（调整后将会更新费用记录，若对下已结算则不予调整）',
            okText: '同步调整',
            cancelText: '不调整',
            width:'450px',
          }).then((res1)=>{
            this.loading = true
              this.$http({
                    url: `/buz/userSettlementData/modifyCheckCommission`,
                    type: 'POST',
                    data: {
                      commissionLogIds: res.data.commissionLogIds
                    }
                }).then(res3 => {
                    this.$http({
                      url: '/buz/userSettlementData/confirmTransferSettle',
                      type: 'POST',
                      data: params
                    }).then(res3 => {
                      this.visible = false;
                      this.$notice.success('转入结算报表成功');
                      this.$emit('success');
                      this.loading = false
                    });
                }).catch(()=>{
                  this.loading = false
                });
              }).catch((res2)=>{
              this.loading = true
              this.$http({
                url: '/buz/userSettlementData/confirmTransferSettle',
                type: 'POST',
                data: params
              }).then(res => {
                this.visible = false;
                this.$notice.success('转入结算报表成功');
                this.$emit('success');
                this.loading = false
              }).catch(()=>{
                this.loading = false
              });
            });
        }else{
          this.$http({
            url: '/buz/userSettlementData/confirmTransferSettle',
            type: 'POST',
            data: params
          }).then(res => {
            this.visible = false;
            this.$notice.success('转入结算报表成功');
            this.$emit('success');
          });

        }
      });
      
    },
  }
};
</script>

<style lang="scss" scoped>
null{
  padding-left: 10px;
  line-height: 30px;
  white-space: nowrap;
}
/deep/ .ivu-modal-wrap .ivu-modal{
  top: 5vh!important;
}
/deep/.input-item.select-two.select-two1>:nth-child(1){
    width: 114px!important;
}
/deep/ .ivu-modal-footer{
  z-index: 1000 !important;
}
.search-tools {
  margin-top: 20px;
}
/deep/ .ivu-modal-header-inner{
  height: 40px;
  line-height: 40px;
}
/deep/ .ivu-modal-body{
  padding-top: 10px !important;
}
.table {
  margin-top: 20px;
}

.pageBox {
  margin-top: 10px;
}

/deep/ .ivu-table-tip table {
  min-height: 380px;
}

/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #ccc;
  color: #ccc;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}

.text{
  line-height: 30px;
}
.toDetailPage{
  color: #236DFF;
  cursor: pointer;
}
</style>
